import { render, staticRenderFns } from "./ManageAmazingTeam.vue?vue&type=template&id=5d4350ba&scoped=true&"
import script from "./ManageAmazingTeam.vue?vue&type=script&lang=js&"
export * from "./ManageAmazingTeam.vue?vue&type=script&lang=js&"
import style0 from "./ManageAmazingTeam.vue?vue&type=style&index=0&id=5d4350ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4350ba",
  null
  
)

export default component.exports